import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

const TUTOR_PASSWORD = 'okiedokie2025';

export default function Login({ onLogin }) {
  const [role, setRole] = useState(null);
  const [studentId, setStudentId] = useState('');
  const [pin, setPin] = useState('');
  const [tutorPass, setTutorPass] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleTutorLogin = () => {
    if (tutorPass === TUTOR_PASSWORD) onLogin({ role: 'tutor' });
    else setError('Wrong password. Try again!');
  };

  const handleStudentParentLogin = async (loginRole) => {
    setLoading(true); setError('');
    const { data, error: dbErr } = await supabase.from('students').select('id,name,student_pin,parent_pin').eq('student_code', studentId.trim().toUpperCase()).single();
    if (dbErr || !data) { setError("We couldn't find that Student ID. Double-check and try again!"); setLoading(false); return; }
    const correct = loginRole === 'student' ? data.student_pin : data.parent_pin;
    if (pin !== correct) { setError('Wrong PIN. Try again!'); setLoading(false); return; }
    onLogin({ role: loginRole, studentId: data.id, studentName: data.name });
    setLoading(false);
  };

  const roleConfig = [
    { key: 'tutor', emoji: '👩‍🏫', label: 'Tutor', bg: '#20396B', light: '#e8edf5' },
    { key: 'student', emoji: '📚', label: 'Student', bg: '#36B7A6', light: '#d0f0ec' },
    { key: 'parent', emoji: '👪', label: 'Parent', bg: '#F2A7C0', light: '#FBDDE6' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #FBDDE6 0%, #FCF6EC 50%, #d0f0ec 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 28, padding: '40px 36px', maxWidth: 420, width: '100%', boxShadow: '0 8px 40px rgba(32,57,107,0.12)', textAlign: 'center' }}>
        
        {/* Logo area */}
        <div style={{ fontSize: 48, marginBottom: 4 }}>🐰</div>
        <div style={{ fontFamily: 'var(--font-head)', fontSize: 26, fontWeight: 700, color: '#20396B', marginBottom: 2 }}>OkieDokie</div>
        <div style={{ fontFamily: 'var(--font-body)', fontSize: 13, color: '#F2A7C0', fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 28 }}>English Academy</div>

        {!role ? (
          <>
            <div style={{ fontSize: 15, color: '#8a9ab8', marginBottom: 20, fontWeight: 600 }}>Who is logging in today?</div>
            <div style={{ display: 'flex', gap: 10 }}>
              {roleConfig.map(r => (
                <button key={r.key} onClick={() => { setRole(r.key); setError(''); }}
                  style={{ flex: 1, padding: '14px 8px', borderRadius: 16, border: `2px solid ${r.light}`, background: r.light, color: r.bg, fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-body)', cursor: 'pointer', transition: 'all 0.15s' }}>
                  <div style={{ fontSize: 24, marginBottom: 4 }}>{r.emoji}</div>
                  {r.label}
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 15, color: '#8a9ab8', fontWeight: 600, marginBottom: 20 }}>
              {role === 'tutor' ? '👩‍🏫 Tutor login' : role === 'student' ? '📚 Student login' : '👪 Parent login'}
            </div>

            {role === 'tutor' ? (
              <>
                <label style={{ fontSize: 13, color: '#8a9ab8', display: 'block', textAlign: 'left', marginBottom: 6, fontWeight: 600 }}>Password</label>
                <input type="password" value={tutorPass} onChange={e => setTutorPass(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleTutorLogin()}
                  style={{ width: '100%', padding: '12px 14px', borderRadius: 12, border: '2px solid #e8edf5', fontSize: 15, outline: 'none', marginBottom: 4 }}
                  placeholder="Enter password" autoComplete="off" />
                <button onClick={handleTutorLogin}
                  style={{ width: '100%', padding: 14, borderRadius: 14, background: '#20396B', color: '#fff', fontSize: 15, fontWeight: 700, fontFamily: 'var(--font-body)', marginTop: 14, boxShadow: '0 4px 12px rgba(32,57,107,0.25)' }}>
                  Let me in 🚀
                </button>
              </>
            ) : (
              <>
                <label style={{ fontSize: 13, color: '#8a9ab8', display: 'block', textAlign: 'left', marginBottom: 6, fontWeight: 600 }}>Student ID</label>
                <input type="text" value={studentId} onChange={e => setStudentId(e.target.value)}
                  style={{ width: '100%', padding: '12px 14px', borderRadius: 12, border: '2px solid #e8edf5', fontSize: 15, outline: 'none', marginBottom: 14 }}
                  placeholder="e.g. OKD-2025-EMMA" autoComplete="off" autoCorrect="off" autoCapitalize="characters" spellCheck={false} />
                <label style={{ fontSize: 13, color: '#8a9ab8', display: 'block', textAlign: 'left', marginBottom: 8, fontWeight: 600 }}>
                  {role === 'student' ? 'Student' : 'Parent'} PIN
                </label>
                <PinInput value={pin} onChange={setPin} />
                <button onClick={() => handleStudentParentLogin(role)} disabled={loading}
                  style={{ width: '100%', padding: 14, borderRadius: 14, background: role === 'student' ? '#36B7A6' : '#F2A7C0', color: role === 'student' ? '#fff' : '#20396B', fontSize: 15, fontWeight: 700, fontFamily: 'var(--font-body)', marginTop: 14, boxShadow: `0 4px 12px ${role === 'student' ? '#36B7A655' : '#F2A7C055'}` }}>
                  {loading ? 'Checking...' : 'Log in ✨'}
                </button>
              </>
            )}

            {error && <div style={{ color: '#e05c7a', fontSize: 13, marginTop: 12, background: '#FBDDE6', padding: '8px 12px', borderRadius: 10 }}>😬 {error}</div>}
            <div onClick={() => { setRole(null); setError(''); setPin(''); setStudentId(''); setTutorPass(''); }}
              style={{ marginTop: 16, fontSize: 13, color: '#8a9ab8', cursor: 'pointer', textDecoration: 'underline' }}>← Back</div>
          </>
        )}
      </div>
    </div>
  );
}

function PinInput({ value, onChange }) {
  const refs = [React.createRef(), React.createRef(), React.createRef(), React.createRef()];
  const digits = (value + '    ').slice(0, 4).split('');
  const handleKey = (i, e) => {
    if (e.key >= '0' && e.key <= '9') {
      onChange((value.slice(0, i) + e.key + value.slice(i + 1)).trim());
      if (i < 3) refs[i + 1].current.focus();
      e.preventDefault();
    } else if (e.key === 'Backspace') {
      onChange(value.slice(0, i) + value.slice(i + 1));
      if (i > 0) refs[i - 1].current.focus();
      e.preventDefault();
    }
  };
  return (
    <div style={{ display: 'flex', gap: 10, justifyContent: 'center', margin: '0 0 4px' }}>
      {[0,1,2,3].map(i => (
        <input key={i} ref={refs[i]} type="password" inputMode="numeric" maxLength={1}
          value={digits[i].trim()} onKeyDown={e => handleKey(i, e)} onChange={() => {}}
          style={{ width: 56, height: 60, borderRadius: 14, border: '2px solid #e8edf5', fontSize: 24, textAlign: 'center', outline: 'none', background: '#FCF6EC' }}
          autoComplete="off" spellCheck={false} />
      ))}
    </div>
  );
}
